import * as React from 'react';
import styled from '@emotion/styled';
export const Container = styled.div`
		height: 100%;
		background-color:white !important;
		background-size: 50px 50px;
		display: flex;
		/*border: 1px solid black;*/

		> * {
			height: 100%;
			width: 100%;
		}
		background-image: linear-gradient(
				0deg,
				transparent 24%,
				${p => p.color} 25%,
				${p => p.color} 26%,
				transparent 27%,
				transparent 74%,
				${p => p.color} 75%,
				${p => p.color} 76%,
				transparent 77%,
				transparent
			),
			linear-gradient(
				90deg,
				transparent 24%,
				${p => p.color} 25%,
				${p => p.color} 26%,
				transparent 27%,
				transparent 74%,
				${p => p.color} 75%,
				${p => p.color} 76%,
				transparent 77%,
				transparent
			);
	`;
export class MainCanvasWidget extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(Container, {
      background: this.props.background || 'rgb(60, 60, 60)',
      color: this.props.color || 'rgba(0,0,0, 0.15)'
    }, this.props.children);
  }

}